<template>
  <div v-if="visible">
    <div class="dim">
      <div class="modal" id="myModal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel">
        <div class="modal-dialog" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <div class="modal-title" id="myModalLabel">
                <h4>강의 선택하기</h4>
                <p>구성할 강의를 선택하세요.</p>
              </div>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close"
                      @click="close()"><span aria-hidden="true">×</span></button>
            </div>
            <div class="modal-body">
              <div class="form-group float-left clear w-100per">
                <input @keyup.enter="getLectures()" v-model="filter.searchTitle" type="text"
                       class="form-control fl w-50per"
                       placeholder="검색할 배너 타이틀을 입력하세요.">
              </div>
              <div class="form-group float-left clear w-100per">
                <select @change="getLectures()" v-model="filter.isUse"
                        class="form-control fl w-30per">
                  <option value="">사용여부 선택</option>
                  <option value="Y">Y</option>
                  <option value="N">N</option>
                </select>
                <span class="fl ml-2" style="font-size:20px;">등록일:</span>
                <input  class="form-control fl ml-2 w-15per" v-model="filter.startDate" type="date" placeholder="yyyy-mm-dd"/>
                <span  class="fl ml-1 mr-1">~</span>
                <input  class="form-control fl w-15per" v-model="filter.endDate" type="date" placeholder="yyyy-mm-dd"/>
                <button type="submit" class="btn btn-primary ml-2 my-1" @click="getLectures()">검색</button>
                <button type="submit" class="btn btn-primary fr" @click="goLectureAdd()">등록
                </button>
              </div>
              <div class="mt-20" style="max-height: 450px; overflow-y: scroll; border: 1px solid #e8ebf1;">
              <table class="table table-hover table-bordered mt-30 text-center">
                  <tr>
                    <th class="w-10px"><input type="checkbox" v-model="checkall" @change="setCheckAll"></th>
                    <th class="w-10per">No</th>
                    <th class="w-10per">강의번호</th>
                    <th class="w-30per">강의타이틀</th>
                    <th class="w-10per">사용여부</th>
                    <th class="w-10per">퀴즈</th>
                    <th class="w-15per">AI Speaking</th>
                    <th class="w-15per">등록일</th>
                  </tr>
                  <tr v-for="(item,index ) in lectures" :key="item.idx">
                    <td><input type="checkbox" v-model="item.check"></td>
                    <td>{{ (result.total - (result.currentPage - 1) * result.perPage  ) - index }}</td>
                    <td>L{{ item.idx }}</td>
                    <td><a :href="'/ailecturemodify/' + item.idx">{{ item.title }}</a></td>
                    <td>{{ item.isUse }}</td>
                    <td>{{ item.isQuiz }}</td>
                    <td>{{ item.isSpeaking }}</td>
                    <td>{{ item.createDate }}</td>
                  </tr>
                  <tr v-if="lectures.length === 0">
                    <td colspan="8">검색 결과가 존재하지 않습니다.</td>
                  </tr>
              </table>
              </div>
              <div v-if="lectures.length !== 0" style="padding-left:40%; padding-top:20px;">
                <paginate :page-count="lastpage" :page-range="3" :margin-pages="2"
                          :click-handler="clickCallback" :prev-text="'Prev'"
                          :next-text="'Next'" :container-class="'pagination'"
                          :page-class="'page-link'">
                </paginate>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import Paginate from 'vuejs-paginate';
export default {
  name: 'tutorModal',
  components: {
    Paginate,
  },
  props: {
    visible: {
      type: Boolean,
      require: true,
      default: false
    },
  },

  data: () => ({
    lectures: [],
    filter: {
      page: 1,
      searchTitle: '',
      isUse: ''
    },
    is_preview: false,
    lastpage: 1,
    banner_idx: 0,
    banner_img: "",
    bannerType: '',
    checkall:false,
    lec_total:0,
  }),

  watch: {
    visible: function (newVal) {
      if (newVal == true) {
        this.visible = true;
        // this.doSearch();
      } else {
        this.visible = false;
      }
    }
  },
  mounted() {
    this.getLectures();
  },

  methods: {
    setCheckAll : function() {
      console.log(this.lectures);
      for(let i=0;i<this.lectures.length;i++) {
        this.lectures[i].check = this.checkall;
      }
    },
    initPage: function () {
      this.getLectures();
    },
    clickCallback: function (pageNum) {
      // console.log(pageNum)
      this.filter.page = pageNum;
      this.initPage();
    },
    getLectures: function (page) {
      if (page !== undefined) {
        this.filter.page = page;
      }
      const url = this.$store.state.host + "/v1/aitutor/lecture";
      var params = {
        isUse: (this.filter.isUse === '' ? null : this.filter.isUse),
        page: (this.filter.page === '' ? null : this.filter.page),
        searchTitle: (this.filter.searchTitle === '' ? null : this.filter.searchTitle)
      };

      this.axios.get(url, {
        params
      }).then((res) => {
        if (res.data.status === 0) {
          this.result = res.data.result;
          this.lectures = res.data.result.value;
          this.lastpage = res.data.result.lastPage;
          this.lec_total=res.data.lec_total;
          for(let i=0;i<this.lectures.length;i++) {
            this.lectures[i].check = this.checkall;
          }
        } else {
          console.log('검색실패', res)
          this.lec_total=res.data.lec_total;
          this.lectures = [];
        }
      })
      .catch(error =>{ alert(`network error = ${error}`)});
    },
    pickCategory(category) {
      this.$emit('pick', category);
      this.close();
    },
    close() {
      this.$emit("close", false);
    },
    goLectureAdd: function(){
      let list = [];
      for(let i=0;i<this.lectures.length;i++) {
        if(this.lectures[i].check == true) {
          list.push(this.lectures[i]);
        }
      }

      if(list.length==0){
        alert("선택된리스트가 없습니다")
        return;
      }

      this.$emit('selected', {lectures : list});
      this.$emit("close", false);
    },
  }
}
</script>

<style lang="scss" scoped>
.dim {
  background: rgba(0, 0, 0, 0.7);
  width: 100%;
  height: 100%;
  position: fixed;
  left: 0;
  top: 0;
  box-sizing: border-box;
  z-index: 1000;
}

.modal {
  display: block;
}
</style>
